import * as tslib_1 from "tslib";
// TODO: Needs furthur refactoring
var numConsts = {
    scale: {
        fh: 500,
        ot: 1000,
        tfh: 2500,
        ft: 5000,
        tt: 10000
    },
    percent: 100,
    maxPadding: 99,
    facts: {
        seven: 7,
        width: 8,
        depth: 9,
        wideSideInd: 10,
        structWide: 11
    }
};
var Segment = /** @class */ (function () {
    function Segment(data) {
        this.segmentNumber = data.segmentNumber;
        this.countyCode = data.countyCode;
        this.stateRouteNumber = data.stateRouteNumber;
        this.streetName = data.streetName;
        this.cumOffsetBegin = data.cumOffsetBegin;
        this.cumOffsetEnd = data.cumOffsetEnd;
        this.length = data.length;
        this.sideIndicator = data.sideIndicator;
        this.latLongs = data.latLongs;
    }
    Segment.prototype.isIntersectionForSelectedSegment = function (intersection) {
        // Return true if intersection's segment matches selected segment <OR>
        // if the intersection's segment matches the next segment and is at offset 0 so
        // that we can see that intersection at the end of our current selected segment bar
        return intersection.segmentNumber === this.segmentNumber ||
            (intersection.segmentNumber === this.next.segmentNumber && this.next.segmentNumber && intersection.segmentOffset === 0);
    };
    return Segment;
}());
export { Segment };
var SegmentData = /** @class */ (function () {
    function SegmentData(data) {
        // Constants
        this.intersectionTypesAboveOnly = ['AHEADL', 'ALENTR', 'ALEXIT', 'BACKL', 'BLENTR', 'BLEXIT', 'TLEFT', 'TLENTR', 'TLEXIT'];
        this.intersectionTypesBelowOnly = ['AHEADR', 'ARENTR', 'AREXIT', 'BACKR', 'BRENTR', 'BREXIT', 'TRIGHT', 'TRENTR', 'TREXIT'];
        this.colors = ['006', '060', '900', 'C30', '030', '066', '09C', 'C33', '960', '33C', 'C60',
            '930', '906', '909', '390', '369', '39F', '936', '396', '06C', 'C66', '000'];
        this.usedColors = [];
        this.name = data.name;
        this.countyCode = data.countyCode;
        this.countyName = data.countyName;
        this.sideIndicator = data.sideIndicator;
        this.segmentBegin = data.segmentBegin;
        this.segmentEnd = data.segmentEnd;
        this.segments = data.segments.map(function (seg) { return new Segment(seg); });
        this.intersections = this.getIntersections(data.intersections);
        this.length = data.length;
        this.attributes = this.getAttributes(data.attributes, this.segments[0], this.segments);
    }
    Object.defineProperty(SegmentData.prototype, "scale", {
        // Derived
        get: function () {
            var _this = this;
            var vals = [numConsts.scale.fh, numConsts.scale.ot, numConsts.scale.tfh, numConsts.scale.ft, numConsts.scale.tt].filter(function (val) { return val < _this.segments[0].length; });
            vals.push(this.length);
            return vals.map(function (val, i, arr) { return ({
                value: val,
                width: ((i === 0 ? arr[i] : (arr[i] - arr[i - 1]))) / _this.length * numConsts.percent
            }); });
        },
        enumerable: true,
        configurable: true
    });
    SegmentData.prototype.getAttributes = function (attributes, segment, segments) {
        var _this = this;
        if (attributes && segment && segments) {
            attributes.forEach(function (attr, attrIndex) {
                attr.tablePartitionedByYear = attr.table.toUpperCase() === 'PAVEMENT_HISTORY';
                _this.usedColors = [];
                attr.item.forEach(function (datum, index) {
                    datum.isOverlap = false;
                    datum.boundedOffsetBegin = Math.max(datum.cumOffsetBegin, segment.cumOffsetBegin);
                    datum.boundedOffsetEnd = Math.min(datum.cumOffsetEnd, segment.cumOffsetEnd);
                    datum.attributeBarSize = datum.boundedOffsetEnd - datum.boundedOffsetBegin;
                    datum.hidden = false;
                    datum.padding = null;
                    datum.width = null;
                    datum.isSameYearAsLast = false;
                    //sets sameYearAsLast to break by year in pavement history
                    if (index !== 0) {
                        for (var j = index - 1; j >= 0; j--) {
                            if (!attr.item[j].hidden) {
                                if (attr.item[j].facts[0] === datum.facts[0]) {
                                    datum.isSameYearAsLast = true;
                                }
                                j = 0;
                            }
                        }
                    }
                    if ((datum.attributeBarSize === 0 && datum.boundedOffsetBegin === datum.boundedOffsetEnd) || datum.attributeBarSize < 0) {
                        datum.hidden = true;
                    }
                    else {
                        datum.padding = Math.min((datum.boundedOffsetBegin - segment.cumOffsetBegin) / segment.length * numConsts.percent, numConsts.maxPadding);
                        if (index !== 0) {
                            //gets the previous items up till an overlapping item (get all items on the same row)
                            var allPrevious = _this.previousUnhidden(attr.item, index);
                            //sets isOverlap if item is overlapping another that comes before it
                            if (attr.item[index - 1].cumOffsetEnd > datum.cumOffsetBegin || allPrevious.every(function (item) { return item.cumOffsetEnd > datum.cumOffsetBegin; })) {
                                datum.isOverlap = true;
                            }
                            else {
                                //changes padding based on the width and padding of items before on same line
                                if (allPrevious.length > 0) {
                                    datum.padding = Math.max(datum.padding - (allPrevious.flatMap(function (prevAttr) { return [prevAttr.width, prevAttr.padding]; }).reduce(function (a, b) { return a + b; })), 0);
                                }
                            }
                        }
                        datum.width = datum.attributeBarSize / segment.length * numConsts.percent;
                        if (datum.attributeBarSize !== 0) {
                            datum.color = _this.getColor(datum.description);
                        }
                    }
                    //setup to seperate by year (ex. pavement history data)
                    if (datum.toolTip && datum.toolTip.indexOf('&#10') > -1) {
                        datum.toolTip = datum.toolTip.replace(/&#10/g, '\r\n');
                    }
                    datum.toolTip = datum.toolTip;
                });
                //checks if all items in attribute are hidden or not and sets property
                //gets evaluated in html
                if (attr.item.every(function (item) { return item.hidden; })) {
                    attributes[attrIndex].hasAllHidden = true;
                }
                else {
                    attributes[attrIndex].hasAllHidden = false;
                }
            });
        }
        return attributes;
    };
    SegmentData.prototype.getIntersections = function (intersections) {
        var _this = this;
        var reducedIntersections = intersections.reduce(function (previousArray, currentStreet) {
            var previousStreet = previousArray[previousArray.length - 1];
            if (previousStreet &&
                previousStreet.cumulativeOffset === currentStreet.cumulativeOffset &&
                (_this.intersectionTypesBelowOnly.includes(previousStreet.intersectionType) === _this.intersectionTypesBelowOnly.includes(currentStreet.intersectionType) ||
                    _this.intersectionTypesAboveOnly.includes(previousStreet.intersectionType) === _this.intersectionTypesAboveOnly.includes(currentStreet.intersectionType))) {
                /* Add current street to previous street seperated by a <br> */
                previousStreet.streetName += ' / ' + currentStreet.streetName;
            }
            else {
                /* Just add intersection like normal; Its not overlapping with another */
                previousArray.push(currentStreet);
            }
            return previousArray;
        }, [] /* Start with an empty array */);
        // Set offset
        reducedIntersections.forEach(function (intersection) {
            intersection.offset = (intersection.cumulativeOffset - _this.segments[0].cumOffsetBegin) / _this.length * numConsts.percent;
        });
        return reducedIntersections;
    };
    SegmentData.prototype.fullDescription = function (item) {
        var retVal = null;
        if (item.description !== null) {
            retVal = item.description;
            if (item.facts && item.facts.length > 0) {
                retVal += " " + item.facts[0];
                if (item.facts.length > 1) {
                    retVal += ", " + item.facts[1];
                }
                //
                if (item.facts.length > numConsts.facts.width) { // Depth
                    retVal += ", " + item.facts[numConsts.facts.depth];
                }
                //
                if (item.facts.length > numConsts.facts.wideSideInd) { // Structural/Widening and Widening Side Ind
                    retVal += ", " + item.facts[numConsts.facts.structWide] + ", " + item.facts[numConsts.facts.wideSideInd];
                }
                else if (item.facts.length > numConsts.facts.seven) { // Width
                    retVal += ", " + item.facts[numConsts.facts.width];
                }
            }
        }
        return retVal;
    };
    SegmentData.prototype.previousUnhidden = function (items, currentIndex) {
        var retVal = [];
        //gets all items that come before current item
        items.forEach(function (item, index) {
            if (index < currentIndex) {
                if (!item.hidden) {
                    retVal.push(item);
                }
            }
        });
        //cuts down list of items if one before overlaps
        //this gives us just the items on the same row as the current item
        retVal.slice().reverse().forEach(function (item, index) {
            if (item.isOverlap) {
                retVal.splice(index, retVal.length - (index + 1));
            }
        });
        return retVal;
    };
    SegmentData.prototype.getColor = function (key) {
        var e_1, _a;
        var color = null;
        var keyOfColor = key;
        try {
            for (var _b = tslib_1.__values(this.usedColors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var row = _c.value;
                if (row.key === keyOfColor) {
                    color = row.value;
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (color === null) {
            if (this.usedColors.length === 0) {
                color = this.colors[0];
            }
            else {
                var colorIndex = this.colors.indexOf(this.usedColors[this.usedColors.length - 1].value) + 1;
                if (colorIndex === this.colors.length) {
                    colorIndex = 0;
                }
                color = this.colors[colorIndex];
            }
            this.usedColors.push({ key: keyOfColor, value: color });
        }
        return color;
    };
    return SegmentData;
}());
export { SegmentData };
